import { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import {
  ROUTE_DASHBOARD_ROOT,
  ROUTE_PUBLIC_ROOT,
} from "../shared/app-constants";
import { AppState } from "../shared/app-state";
import SplashScreen from "../shared/splash-screen";
import { AppContext } from "./contexts/app-context";
import DashboardModule from "./modules/dashboard";
import PublicModule from "./modules/public";

const App = () => {
  const { appState, user } = useContext(AppContext);
  if (appState === AppState.Loading) {
    return <SplashScreen />;
  }
  return (
    <Routes>
      <Route path={`${ROUTE_DASHBOARD_ROOT}/*`} element={<DashboardModule />} />
      <Route path={`${ROUTE_PUBLIC_ROOT}/*`} element={<PublicModule />} />
    </Routes>
  );
};

export default App;
